import Link from "next/link";

export default () => (
  <div>
    <nav className="navbar is-light">
      <div className="navbar-brand">
        <Link href="/">
          <a className="navbar-item-custom">
            <img
              className="logo"
              alt="Logo da Universidade Federal da Fronteira Sul"
              title="Universidade Federal da Fronteira Sul - UFFS"
              src="/static/logo-uffs.png"
            />
          </a>
        </Link>
      </div>

      <div className="navbar-menu is-active">
        <div className="navbar-end">
          <Link href="/recomendacoes">
            <a className="navbar-item">Boas práticas</a>
          </Link>

          <Link href="/estatisticas">
            <a className="navbar-item">Estatísticas</a>
          </Link>
        </div>
      </div>
    </nav>

    <section className="hero is-primary">
      <div className="hero-body">
        <div className="container has-text-centered">
          <h1 className="title">Serviço de Videoconferências</h1>
          <h2 className="subtitle">Universidade Federal da Fronteira Sul - UFFS</h2>
        </div>
      </div>
    </section>

    <style jsx>{`
      .hero.is-primary {
        background-color: #00693e;
      }

      .logo {
        height: 100px;
      }

      .navbar-menu {
        flex: 1 0 auto;
        background-color: #f6f5f5;
      }

      .navbar-item {
        font-size: 1.2rem;
      }

      @media only screen and (max-width: 1023px) {
        .navbar-brand {
          text-align: center;
        }

        .navbar-brand .navbar-item-custom {
          width: 100%;
          display: block;
        }

        .navbar-end {
          text-align: center;
          margin-bottom: 20px;
        }

        a.navbar-item:hover {
          background-color: #fff;
        }
      }
    `}</style>
  </div>
);



// WEBPACK FOOTER //
// components/shared/PageHeader.js